import {Expose, Type} from "class-transformer";
import ModelTransferContact from "./ModelTransferContact";
import ModelTransferService from "./ModelTransferService";
import ModelTransferCurrency from "@models/v2/transfer/ModelTransferCurrency";

export default class ModelTransfer {
	@Expose({name: "clientId"})
	private readonly _clientId: number;

	@Expose({name: "login"})
	private readonly _login: string;

	@Expose({name: "shortName"})
	private readonly _shortName: string | null;

	@Expose({name: "rate"})
	private readonly _rate: number;

	@Expose({name: "currency"})
	@Type(() => ModelTransferCurrency)
	private readonly _currency: ModelTransferCurrency;

	@Expose({name: "contact"})
	@Type(() => ModelTransferContact)
	private readonly _contact: ModelTransferContact;

	@Expose({name: "service"})
	@Type(() => ModelTransferService)
	private readonly _service: ModelTransferService;

	constructor(
		clientId: number,
		login: string,
		rate: number,
		shortName: string,
		currency: ModelTransferCurrency,
		contact: ModelTransferContact,
		service: ModelTransferService,
	) {
		this._clientId = clientId;
		this._login = login;
		this._rate = rate;
		this._shortName = shortName;
		this._currency = currency;
		this._contact = contact;
		this._service = service;
	}

	public get clientId() {
		return this._clientId;
	}

	public get login() {
		return this._login;
	}

	public get shortName() {
		return this._shortName;
	}

	public get rate() {
		return this._rate;
	}

	public get currency() {
		return this._currency;
	}

	public get contact() {
		return this._contact;
	}

	public get service() {
		return this._service;
	}
}
